declare global {
	interface Window {
		fbq: (a: string, b: string) => void;
		ym: (trackingId: number, type: string, params: object) => void;
	}
}

import Analytic from '@/models/AnalyticModel';
import TrackingAnalyticData from '@/models/TrackingAnalyticData';
// Устанавливаем пиксели аналитики

function setYandexMetrika(trackingId: string) {
	const data = `(function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
					m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
					(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

					ym(${+trackingId}, "init", {
					clickmap:true,
					trackLinks:true,
					accurateTrackBounce:true,
					webvisor:true,
					trackHash:true
					});`;
	const script = document.createElement('script');
	script.async = true;
	script.textContent = data;
	document.body.appendChild(script);
}

function setFacebookEvents(pixelId: string) {
	const data = `!(function(f, b, e, v, n, t, s) {
					if (f.fbq) return;
					n = f.fbq = function() {
					n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
				};
				if (!f._fbq) f._fbq = n;
				n.push = n;
				n.loaded = !0;
				n.version = '2.0';
				n.queue = [];
				t = b.createElement(e);
				t.async = !0;
				t.src = v;
				s = b.getElementsByTagName(e)[0];
				s.parentNode.insertBefore(t, s);
			})(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');`;
	const script = document.createElement('script');
	script.async = true;
	script.textContent = data;
	document.head.appendChild(script);
	window.fbq('init', pixelId);
	window.fbq('track', 'PageView');
}

function setGoogleAnalytics(trackingId: string) {
	const body = document.querySelector('body');

	if (body) {
		body.insertAdjacentHTML(
			'beforeend',
			`
			<script async src="https://www.googletagmanager.com/gtag/js?id=${trackingId}"></script>
			<script>
				window.dataLayer = window.dataLayer || [];
				function gtag(){dataLayer.push(arguments);}
				gtag('js', new Date());

				gtag('config', '${trackingId}');
			</script>`
		);
	}
}

export default function (analytics: Array<Analytic>) {
	const analyticTracking: TrackingAnalyticData = {
		ymTracking: null
	};
	analytics.forEach((a) => {
		if (a.name === 'facebook_events') {
			setFacebookEvents(a.pixel_id);
		}
		if (a.name === 'google_analytics') {
			setGoogleAnalytics(a.tracking_id);
		}
		if (a.name === 'yandex_metrika') {
			setYandexMetrika(a.tracking_id);
			analyticTracking.ymTracking = +a.tracking_id;
		}
	});
	return analyticTracking;
}
